import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Соревнования переехали с `/tourneys` на `/championships`.
 *
 * У пользователей остались закладки и ссылки в задачах на старый адрес, поэтому
 * он ведёт сюда и отправляет на новый — вместе с id соревнования, вкладкой,
 * query-параметрами и hash-ом. `replace` — чтобы старый адрес не оставался в
 * истории браузера и «назад» работало ожидаемо.
 *
 * Убирать редирект можно не раньше, чем старые ссылки перестанут открывать.
 */
const LegacyTourneysRedirect = () => {
  const location = useLocation();

  const pathname = location.pathname.replace(Pages.LEGACY_TOURNEYS, Pages.CHAMPIONSHIPS.INDEX);

  return <Navigate replace to={{ pathname, search: location.search, hash: location.hash }} />;
};

export default LegacyTourneysRedirect;
